/**
 * Gemeinsame Typen und Grenzen für Veranstaltungen (§6).
 *
 * Nur Konstanten, Typen und reine Prüffunktionen (§41.2). Die Feldlängen stehen hier, damit
 * Formular und Server dieselben Grenzen verwenden — geprüft wird verbindlich serverseitig
 * (§25.2).
 */
/** Status einer Veranstaltung (§6.2). */
export const VERANSTALTUNGSSTATUS_WERTE = [
    'entwurf',
    'freigegeben',
    'laufend',
    'beendet',
    'archiviert',
];
/** Beschriftungen für die Oberfläche (§37: Oberfläche ausschließlich Deutsch). */
export const VERANSTALTUNGSSTATUS_BESCHRIFTUNG = {
    entwurf: 'Entwurf',
    freigegeben: 'Freigegeben',
    laufend: 'Laufend',
    beendet: 'Beendet',
    archiviert: 'Archiviert',
};
/** Feldlängen nach §6.1. */
export const VERANSTALTUNG_GRENZEN = {
    bezeichnung: 200,
    beschreibung: 5000,
    ort: 250,
    interneNotiz: 10000,
};
/** Ob eine Veranstaltung als aktiv gilt — davon hängt §6.3 ab. */
export function istAktiv(status) {
    return status === 'freigegeben' || status === 'laufend';
}
/** Ob die Stammdaten in diesem Status noch bearbeitet werden dürfen (§6.2). */
export function istBearbeitbar(status) {
    return status === 'entwurf' || status === 'freigegeben' || status === 'laufend';
}
/** Ob in diesem Status Tokens erzeugt werden dürfen (§6.2). */
export function erlaubtTokenerzeugung(status) {
    return istBearbeitbar(status);
}
/**
 * Prüft ein Datum im Format `JJJJ-MM-TT` (§37).
 *
 * Bewusst streng: `2026-02-30` wird abgewiesen, obwohl `Date` daraus stillschweigend den
 * 2. März machen würde.
 */
export function istGueltigesDatum(wert) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(wert)) {
        return false;
    }
    const zeitpunkt = new Date(`${wert}T00:00:00.000Z`);
    return !Number.isNaN(zeitpunkt.getTime()) && zeitpunkt.toISOString().startsWith(wert);
}
//# sourceMappingURL=veranstaltung.js.map